import { useSelector } from 'react-redux';
import { t } from '@/utils/i18n';
import { useStickerSize } from '@/hooks/useStickerSize';
import { getIsStickerAppearance } from '@/model/productType/getIsStickerAppearance';
import { getCurrentAppearance } from '@/redux/draft/getters/getCurrentAppearance';
import { Info } from '@/components/common/icons/Info';
import './StickerSizeSelector.scss';

export const StickerSizeSelector = () => {
  const { slider, heightInput, widthInput } = useStickerSize();
  const appearance = useSelector(getCurrentAppearance);
  const isSticker = getIsStickerAppearance(appearance);
  return (
    <>
      <div className="sticker-panel">
        <p className="sticker-panel__title">{t('stickerPanel.title')}</p>
        <div className="sticker-panel__slider">{slider}</div>
        <div className="sticker-panel__labels">
          <label className="sticker-panel__label">
            <strong>{t('stickerPanel.width')}</strong>
            {widthInput}
          </label>
          <label className="sticker-panel__label">
            <strong>{t('stickerPanel.height')}</strong>
            {heightInput}
          </label>
        </div>
      </div>
      {isSticker && (
        <div className="sticker-panel__info">
          <Info className="sticker-panel__icon" />
          <div>{t('stickerPanel.info')}</div>
        </div>
      )}
    </>
  );
};
